import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  INIT_VALUE = null;

  private Language$ = new BehaviorSubject<string>(this.initializeLanguage());
  public Language = this.Language$.asObservable().pipe(distinctUntilChanged());

  constructor(private http: HttpClient, private router: Router) {}

  initializeLanguage() {
    let language = getNavigatorLanguage();

    const lang = JSON.parse(localStorage.getItem('panelLang'));

    return lang ? lang.language : language;
  }

  public setLanguage(language: string) {
    this.Language$.next(language);
  }

  public get currentLanguage(): any {
    return this.Language$.value;
  }

  removeLanguage(): void {
    localStorage.removeItem('panelLang');
    this.Language$.next(null);
  }
}

export const getNavigatorLanguage = () => {
  let lang = '';
  if (navigator.languages && navigator.languages.length) {
    lang = navigator.languages[0];
  } else {
    lang = navigator.language || 'en';
  }

  if (lang.indexOf('-') !== -1) {
    lang = lang.split('-')[0];
  }

  let languages = Object.keys(Languages).map((key) => Languages[key]);
  if (!languages.includes(lang)) lang = 'en';

  return lang;
};

export enum Languages {
  EN = 'en',
  DE = 'de',
  PT = 'pt',
  FR = 'fr'
}
